import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
// You can import getAuth, getFirestore, etc. as needed

const firebaseConfig = {
  apiKey: "AIzaSyCzKzLMQf8UnI9sC-4g2WKtNUeXELVfGIg",
  authDomain: "zazi-apply.firebaseapp.com",
  projectId: "zazi-apply",
  storageBucket: "zazi-apply.appspot.com",
  messagingSenderId: "212152179116",
  appId: "1:212152179116:web:45dcc1470fefcc91d70209",
  measurementId: "G-T82ZP7CFMY"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { app, db };
